/* eslint-disable @typescript-eslint/no-unsafe-argument */
import { InputProps } from '@chakra-ui/input';
import theme from '@chakra-ui/theme';

export const Input = {
  parts: ['field', 'addon'],
  baseStyle: {
    field: {
      color: 'white',
      fontWeight: 'bold',
      caretColor: 'currentColor',
      boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
      '&&': {
        px: '2',
        border: '2px solid',
        borderRightRadius: 'md',
        borderColor: 'beta.300',
        bg: 'alpha.700',
        borderLeft: 'none',
      },

      '&::placeholder': {
        color: 'whiteAlpha.500',
      },

      _hover: {
        '&&': {
          bg: 'alpha.700',
          boxShadow: '0px 0px 8px 0px rgba(173, 241, 6, 0.5)',
          border: '2px solid',
          borderColor: 'beta.300',
          borderLeft: 'none',
        },
      },

      _focus: {
        '&&': {
          border: '2px solid',
          borderColor: 'beta.300',
          borderLeft: 'none',
          bg: 'alpha.900',
          boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
        },
      },

      '&:-webkit-autofill': {
        caretColor: 'currentColor',
        '&:hover, &:focus, &:active': { caretColor: 'currentColor' },
      },
    },
    addon: {
      fontWeight: 'normal',
      fontSize: 'md',
      color: 'blackAlpha.800',
      fontFamily: 'accent',
      pt: '1',
      '&&': {
        borderLeftRadius: 'md',
        bg: 'beta.300',
        border: 'none',
        boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
      },
    },
  },
  sizes: {
    lg: { addon: { borderRadius: 'sm' }, field: { borderRadius: 'sm' } },
    md: { addon: { borderRadius: 'sm' }, field: { borderRadius: 'sm' } },
  },
  variants: {
    unstyled: (props: InputProps) => {
      const { addon, field } = theme.components.Input.variants.outline(
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        props as any
      );

      return {
        addon,
        field: {
          ...field,
          boxShadow: 'none',
          '&&': {
            color: 'black',
            bg: 'white',
            borderRadius: 'base',
            h: '40px',
            borderColor: 'white',
            pl: '2.5',
          },
          '&:focus, &:active, &:hover': {
            '&&': {
              bg: 'white',
              borderColor: 'white',
              color: 'black',
            },
          },
        },
      };
    },
  },
  defaultProps: {},
};
